let swPromise: Promise<ServiceWorkerRegistration> | null = null;

export function getNotificationSW(): Promise<ServiceWorkerRegistration> {
  if (!('Notification' in window) || Notification.permission !== 'granted') {
    return Promise.reject(
      new Error('Notification does not support or permission not granted')
    );
  }

  if (!('serviceWorker' in navigator)) {
    return Promise.reject(new Error('Service worker not supported'));
  }

  if (!swPromise) {
    swPromise = navigator.serviceWorker
      .register('/notification-sw.js', {scope: '/'})
      .then((reg) => {
        reg.update();
        return reg;
      })
      .catch((err) => {
        swPromise = null;
        throw err;
      });
  }
  return swPromise;
}
